import React, { useEffect, useState } from "react";
import "./App.scss";


import { _common } from "./common";
import { ServerInterface } from "./ServerInterface";

import { useNavigate } from "react-router-dom";

const common = _common;


const NEXTPAGE = "profile";

function NewsLetter() {

  const navigate = useNavigate();

  const [src, setSrc] = useState("")

  async function init() {
    if (_common.anzeigeTafelMode) {
      window.location.pathname = "AnzeigeTafel"
    }

    const res = await ServerInterface.getUnreadLastNewsletter({ memberID: _common.userMemberId })

    console.log("res=", res)

    if (res?.unread) {
      const ss = res.unread.split("-");
      setSrc(`https://newsletter.tc-kreuzberg.de/show?y=${ss[0]}&n=${ss[1]}&m=${_common.userMemberId}&s=a`);
    } else {
      //
      // user has read newsletter allready
      //

      // window.location.href = "/registerwebpush";
      window.location.pathname = NEXTPAGE
    }


  }

  useEffect(() => {
    init();
  }, [])


  if (!src) {
    return (
      <div className="App" style={{
        overflow: "hidden",
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        justifyContent: "center",
        alignItems: "center",
      }}>
        <img
          src="/images/Kreuzberg-Logo-600x600.jpg"
          style={{
            height: "auto",
            marginBottom: "50px",
            width: "150px",
            borderRadius: "100px",
            objectFit: "cover",
            boxShadow: "0 0 20px rgba(0, 0, 0, 0.75)",
          }}
        />

      </div>
    )
  }

  return (
    <div className="App" style={{
      overflow: "hidden",
      width: "100vw",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "white",
      justifyContent: "center",
      alignItems: "center",
    }}>

      NewsLetter
      <div style={{ position: "relative", flexGrow: "1", flexShrink: "1", maxWidth: "600px", width: "600px" }}>
        {src &&
          <iframe style={{ position: "relative", height: "100%", width: "400px", maxWidth: "100%" }} title="Newsletter" src={src} />}
      </div>

      <div style={{
        backgroundColor: "darkgreen",
        width: "100%",
        height: "70px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        flexShrink: "0"
      }}>
        <button className="button" style={{ backgroundColor: "orange" }}
          onClick={() => {

            const user = JSON.parse(common.getUserFromLocalStorage());
            const src = `${ServerInterface.serverUrl}/booking/profileImage/?memberId=${user.memberId}`;
            if (src) {
              return navigate("/booking");
            } else {
              window.location.pathname = NEXTPAGE
            }
          }}
        >
          Weiter zum Buchen
        </button>
      </div>
    </div >
  );
}

export default NewsLetter;
